import styled from 'styled-components'
import Left from 'components/Pages/Login/Left'
import Cookies from 'components/Common/Cookies'
import { Location, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useApolloClient } from '@apollo/client'
import { MainContainer, MainWrapper } from '../ForgotPassword/Common/_styles'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

const Right = styled.div``
interface IUseLocation {
  isLogout: boolean
}

const Login = () => {
  const { state }: Location<IUseLocation> = useLocation()
  const [cookiePolicy] = useLocalStorage('wwl-cookie_policy', 'false')
  const client = useApolloClient()

  useEffect(() => {
    if (state?.isLogout) {
      client.resetStore()
    }
  }, [])

  return (
    <MainWrapper>
      {cookiePolicy !== 'true' && <Cookies />}
      <MainContainer>
        <Left />
        <Right />
      </MainContainer>
    </MainWrapper>
  )
}

export default Login
